import React, { useEffect } from "react";
import withRouter from "../Components/Common/withRouter";

//redux
import { useSelector } from "react-redux";

const NonAuthLayout = ({ children }: any) => {
  // Direct selector - no transformation needed, so no createSelector required
  const layoutModeType = useSelector((state: any) => state.Layout.layoutModeType);

  useEffect(() => {
    if (layoutModeType === "dark") {
      document.body.setAttribute("data-bs-theme", "dark");
    } else {
      document.body.setAttribute("data-bs-theme", "light");
    }
    return () => {
      document.body.removeAttribute("data-bs-theme");
    };
  }, [layoutModeType]);
  return <div>{children}</div>;
};

// Export wrapped component with router props
export default withRouter(NonAuthLayout);
